import { baseServiceRequest } from "../baseServiceRequest"
import type { IConversation } from "./types"

export const getConversationItems = async (
  conversationId: string,
): Promise<IConversation[]> => {
  const response = await baseServiceRequest({
    method: "GET",
    url: `/conversations/conversations/${conversationId}/conversation_items`,
  })
  return response.data
}
